<template>
  <div
    class="facetContainer"
    :class="[customClass, ...facetClass, ...paddingClass, ...spinnerOverlay]"
  >
    <Spinner
      v-if="hasLoading"
      class="facetLoader"
    />
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Spinner from '@atomic-ui/spinner';
import useFacets from '../../composables/useFacets';
import useSortFilter from '../../composables/useSortFilter';

const {
  isFacetsLoading,
  globalOptions: { isProductsLoading, isDynamicFilters },
} = useFacets();

const {
  rightSideDrawer,
} = useSortFilter();

const props = defineProps({
  facet: {
    type: Object,
    required: true,
  },
  customClass: {
    type: [Array, Object],
    default: () => ({}),
  },
});

const hasLoading = computed(() => isFacetsLoading.value || (isDynamicFilters.value && isProductsLoading.value));
const notDeliveryPickup = computed(() => props.facet.facetType !== 'DELIVERY_AND_PICKUP');
const facetClass = computed(() => [`facet-type-${props.facet.name}`, `facet-type-${props.facet.facetType}`]);
const paddingClass = computed(() => (!rightSideDrawer.value && notDeliveryPickup.value ? ['facet-padding'] : []));
const spinnerOverlay = computed(() => (hasLoading.value ? ['facetMask'] : []));
</script>

<style lang="scss" scoped>
.facetLoader {
  position: absolute;
  top: 50%;
  left: 50%;
}

.facetMask {
  width: 100%;
  pointer-events: none;
  opacity: 0.5;
  z-index: 2;
  background-color: #fff;
}

.facet-padding {
  :deep(.checkbox-wrapper) {
    margin-bottom: 24px !important;
  }
  &.facet-type-Price {
    :deep(.actions-row) {
      margin-top: 32px !important;
    }
    :deep(form > p) {
     margin-top: 8px !important;
   }
  }
}
</style>
